import { ThemeBus } from "@theme/events-bus";
import { EVENTS } from "@theme/event-constants";

async function waitForRelatedSliderInit() {
  for (let attempt = 0; attempt < 100; attempt += 1) {
    if (typeof window.initRelatedProductSlidersWhenReady === 'function') {
      break;
    }

    await new Promise((resolve) => requestAnimationFrame(resolve));
  }

  if (typeof window.initRelatedProductSlidersWhenReady !== 'function') {
    return;
  }

  for (let attempt = 0; attempt < 5; attempt += 1) {
    await window.initRelatedProductSlidersWhenReady();

    const slider = document.querySelector('.product-recommendations [data-slider-block]');
    if (slider?.querySelector('.swiper-initialized')) {
      return;
    }

    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  }
}

/**
 * Related Products Component
 * Loads product recommendations on product pages before slider initialization
 */
class RelatedProducts {
  constructor() {
    this.section = document.querySelector('.product-recommendations[data-url]');

    if (!this.section?.dataset.url) {
      return;
    }

    this.ready = this.loadRecommendations();
  }

  async loadRecommendations() {
    const url = this.section.dataset.url;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations[data-url]');

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.section.classList.add('animate-in');
        this.section.innerHTML = recommendations.innerHTML;

        ThemeBus.dispatchEvent(new Event(EVENTS.gridUpdated));

        await waitForRelatedSliderInit();
      }
    } catch (error) {
      // Silent fail
    }
  }
}

async function bootstrapRelatedProducts() {
  const section = document.querySelector('.product-recommendations[data-url]');

  if (!section?.dataset.url) {
    window.__resolveRelatedProductsReady?.();
    return;
  }

  try {
    const instance = new RelatedProducts();
    await instance.ready;
  } finally {
    window.__resolveRelatedProductsReady?.();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapRelatedProducts, { capture: true });
} else {
  bootstrapRelatedProducts();
}

window.addEventListener('pageshow', () => {
  const slider = document.querySelector('.product-recommendations [data-slider-block]');
  if (slider && !slider.querySelector('.swiper-initialized')) {
    waitForRelatedSliderInit();
  }
});

window.addEventListener('load', () => {
  const slider = document.querySelector('.product-recommendations [data-slider-block]');
  if (slider && !slider.querySelector('.swiper-initialized')) {
    waitForRelatedSliderInit();
  }
}, { once: true });

export async function initRelatedProducts() {
  await window.__relatedProductsReady;
}

export { bootstrapRelatedProducts };
